export const PERM = {
  appCampaigns: "applications.campaigns.view_relevant",
  products: "products.view",
  recurring: "sales.recurring.view",
  salesCampaigns: "sales.campaigns.view",
  users: "manage.agents.view",
  roles: "manage.roles.view",
  partnerForm: "manage.partner_form.view",
  branches: "manage.branches.manage",
  groups: "manage.groups.manage",
  manageModule: "manage.module",
  importsModule: "imports.view_history",
  settingsSecrets: "manage.settings.view_secrets",
  salesOrders: "sales.salesorders.view",
  invoices: "sales.invoices.view",
  residuals: "reporting.residuals.view_relevant",
  ticketTemplateCreate: "tickets.templates.create",
  ticketTemplateEdit: "tickets.templates.edit",
  ticketTemplateDelete: "tickets.templates.delete",
  ticketTemplateInsert: "tickets.templates.insert",
} as const;
